export const isOwnChatMessage = (messageUserId, connectedUserId) =>
  messageUserId != null &&
  connectedUserId != null &&
  String(messageUserId) === String(connectedUserId);

export const getChatMessageLayout = (messageUserId, connectedUserId) => {
  const isOwn = isOwnChatMessage(messageUserId, connectedUserId);

  return {
    isOwn,
    rowClassName: isOwn ? "flex-row-reverse" : "",
    bubbleClassName: isOwn
      ? "bg-[#F4F4F4] rounded-tl-xl rounded-b-xl"
      : "bg-[#FFF2EA] rounded-tr-xl rounded-b-xl",
  };
};
